export default __webpack_public_path__ + "static/1-3da0c100af6bc6df1e13ca49d5da730f.jpg";